export default __webpack_public_path__ + "static/media/trust-in-teams.c00b8cde.svg";